import { Spinner } from '@/components/Spinner';
import { useGroupDetail } from './hooks/useGroupDetail';
import { ManageGroupsForm } from './ManageGroupsForm';

const ManageGroupsFormContainer = ({ id }: { id?: string }) => {
  const { groupDetail, isLoading } = useGroupDetail(id || '');

  const defaultValues = {
    groupName: groupDetail?.groupName ?? '',
    groupNameKatakana: groupDetail?.groupNameKatakana ?? '',
    groupCoverImage: groupDetail?.groupCoverImage?.path ?? '',
    description: groupDetail?.description ?? '',
  };

  if (isLoading) return <Spinner />;
  return <ManageGroupsForm defaultValues={defaultValues} groupId={id} />;
};

export default ManageGroupsFormContainer;
